/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_A2Inputs */

const en_pc_online_faq_a2 = /** @type {(inputs: Pc_Online_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The app runs entirely in your browser tab and has no server-side code. Your file is read from your disk and saved back as a download.`)
};

const zh_pc_online_faq_a2 = /** @type {(inputs: Pc_Online_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。应用完全在你的浏览器标签页中运行，没有服务器端代码。文件从你的磁盘读取，并以下载的形式保存回来。`)
};

/**
* | output |
* | --- |
* | "No. The app runs entirely in your browser tab and has no server-side code. Your file is read from your disk and saved back as a download." |
*
* @param {Pc_Online_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_a2 = /** @type {((inputs?: Pc_Online_Faq_A2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_A2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_a2(inputs)
	return zh_pc_online_faq_a2(inputs)
});
export { pc_online_faq_a2 as "pc.online.faq.a2" }